import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { AppMark } from "../palmtree/shell";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileGlobalSearch } from "../search/GlobalSearch";
import { MobileNavigation } from "./MobileNavigation";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-10 bg-background border-b border-border px-4 py-3">
        <div className="flex items-center gap-3">
          <AppMark size="sm" />
          <h1 className="font-heading text-base font-extrabold">PalmTree</h1>
          <div className="ml-auto">
            <MobileGlobalSearch />
          </div>
        </div>
      </header>
      <div className="pt-16 px-5 pb-[calc(var(--spacing)*18+16px+env(safe-area-inset-bottom,0px))]">
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </div>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
    </>
  );
};
